
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/books/the-art-of-readable-code",
      function () {
        return require("private-next-pages/books/the-art-of-readable-code.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/books/the-art-of-readable-code"])
      });
    }
  